// 询价接口参数缓存
const __KEY__ = '__hotelDetailForOrderPayload__';

export const getHotelDetailForOrderPayload = () => {
  try {
    return JSON.parse(sessionStorage.getItem(__KEY__) || '');
  } catch (error) {
    return null;
  }
};

export const setHotelDetailForOrderPayload = (v: string) => {
  sessionStorage.setItem(__KEY__, v);
};

export const rmHotelDetailForOrderPayload = () => {
  sessionStorage.removeItem(__KEY__);
};
